import React, { useContext } from "react";
import useSWR from "swr";
import mobileProOne from "../../../../../src/assets/sicunetApps/Sicunet -Mobile Pro-site menu 2.1.webp";
import mobileProTwo from "../../../../../src/assets/sicunetApps/Sicunet Mobile - Schedule 3.1.webp";
import mobileProThree from "../../../../../src/assets/sicunetApps/Sicunet -Mobile Pro-login 4.1.png";
import mobilePro from "../../../../../src/assets/sicunetApps/Sicunet_Mobile Pro-site menu-1.1.webp";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";
import FeatureCardView from "../../../../global/components/ProductView/FeatureCardView";
import GooglePlayButton from "../../../../assets/svg/ContentView/GooglePlayButton";
import AppleStoreButton from "../../../../assets/svg/ContentView/AppleStoreButton;";
import UserIcon from "../../../../assets/svg/ContentView/UserIcon";
import MobilePro from "../../../../assets/svg/ContentView/MobilePro";


// ── Video Tutorials (You can replace null with real thumbnails later) ──
const videoTutorials = [
  { title: "How to Setup", subtitle: "Learn how to setup Sicunet Mobile Pro", thumbnail: null },
  { title: "How to Setup", subtitle: "Learn how to setup Sicunet Mobile Pro", thumbnail: null },
  { title: "How to Setup", subtitle: "Learn how to setup Sicunet Mobile Pro", thumbnail: null },
  { title: "How to Setup", subtitle: "Learn how to setup Sicunet Mobile Pro", thumbnail: null }
];

const MobileProContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR("products/", fetcher);
  const { isLoggedIn } = useContext(LoginContext);

  return (
    <div className="bg-white font-['Poppins'] text-[#111827]">

      {/* ====================== HERO ====================== */}
      <section className="max-w-[1200px] mx-auto px-6 pt-28 sm:pt-20 lg:pt-16 pb-6 flex flex-col lg:flex-row justify-between items-center gap-8 lg:gap-12">
        {/* Left Text */}
        <div className="flex-1 max-w-full lg:max-w-[853px] text-center lg:text-left">
          <h1 className="text-[#2E4FA2] text-[28px] sm:text-[36px] lg:text-[42px] font-semibold leading-[1.1] mb-6">
            Sicunet Mobile Pro       </h1>
          <p className="text-black text-[18px] sm:text-[20px] lg:text-[24px] font-medium leading-[1.6] lg:leading-[42px] mb-6">
            Take complete control of your security and access system with professional-grade management tools.        </p>

          <p className="text-[#555] text-sm leading-[1.7] max-w-[680px] mb-8 mx-auto lg:mx-0">
            Sicunet Mobile Pro is built for administrators, operators, and system managers who need deeper control, faster access, and more flexibility on the go.        </p>
          {/* <div className="flex justify-center lg:justify-start">
            <button
              className="inline-flex h-12 px-6 items-center justify-center gap-3 rounded-[42px] bg-[#002B98] text-white text-sm font-semibold hover:bg-[#001f6e] transition-colors"
            >
              Setup Tutorial */}
          {/* Play icon */}
          {/* <span className="flex items-center justify-center w-6 h-6 rounded-full ">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM10.783 7.99L16.427 11.126C16.5828 11.2126 16.7126 11.3393 16.803 11.493C16.8934 11.6467 16.9411 11.8217 16.9411 12C16.9411 12.1783 16.8934 12.3533 16.803 12.507C16.7126 12.6607 16.5828 12.7874 16.427 12.874L10.783 16.01C10.6002 16.1116 10.3941 16.1636 10.1851 16.161C9.97599 16.1584 9.77123 16.1013 9.59107 15.9952C9.4109 15.8891 9.26159 15.7377 9.15791 15.5562C9.05424 15.3746 8.9998 15.1691 9 14.96V9.04C8.9998 8.83092 9.05424 8.62541 9.15791 8.44384C9.26159 8.26227 9.4109 8.11094 9.59107 8.00484C9.77123 7.89874 9.97599 7.84156 10.1851 7.83895C10.3941 7.83635 10.6002 7.88842 10.783 7.99Z" fill="white" />
                </svg>
              </span>
            </button>
          </div> */}
        </div>

        {/* Right Phone */}
        <div className="flex-shrink-0 w-[260px] h-[310px] sm:w-[360px] sm:h-[430px] lg:w-[498px] lg:h-[594px] pt-4 lg:pt-10">
          <img
            src={mobilePro}
            alt="Sicunet Mobile Pro App"
            className="w-full h-full object-contain drop-shadow-2xl"
          />
        </div>
      </section>

      {/* ====================== DOWNLOAD ====================== */}
      <div className="flex flex-col items-center gap-3 pb-16 px-4">
        <p className="text-black text-2xl font-medium">Download Now</p>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="https://play.google.com/store/apps/details?id=bd.sicunet.webapppro&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-90 transition-opacity"
          >
            <GooglePlayButton />
          </a>

          <a
            href="https://apps.apple.com/br/app/sicunet-mobile-pro/id6760539703"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-90 transition-opacity"
          >
            <AppleStoreButton />
          </a>
        </div>
      </div>

      {/* ====================== FEATURE CARDS ====================== */}
      <section className="max-w-[1200px] mx-auto px-6 pb-10 space-y-4">

        <FeatureCardView
          imageLeft={true}
          image={mobileProOne}
          icon={<MobilePro />}
          title="Sicunet Mobile Pro"
          description="Managing large or complex systems requires more than basic monitoring. Sicunet Mobile Pro provides extended capabilities to handle critical operations from your smartphone, reducing the need for constant desktop access and allowing you to respond instantly when it matters."
          brief="With a powerful dashboard, you can quickly review system status, events, and key information in real time. The app allows you to monitor live video feeds, manage access control, and handle permissions with greater precision. Whether it's controlling doors, updating credentials, or responding to alerts, everything is available in one place."
        />

        <FeatureCardView
          imageLeft={false}
          image={mobileProTwo}
          description="Advanced scheduling and reporting features help you manage system operations more effectively. You can create detailed schedules, review activity logs, and analyze reports to maintain security and improve decision-making. Device management tools give you control over connected hardware, making it easier to monitor system health and configuration."
          brief="Sicunet Mobile Pro also supports user and system management, including web user control and integration with external services. Built-in service tools allow you to perform maintenance tasks and ensure smooth system operation at all times."
        />

        <FeatureCardView
          imageLeft={true}
          image={mobileProThree}
          description="This app is ideal for organizations that require a higher level of control and reliability in their access control system. It helps reduce response time, improve efficiency, and keep everything under control, even when you are away from your workstation."
          brief="Using Sicunet Mobile Pro is simple. Log in, access your system dashboard, monitor activity, manage devices and users, and take action instantly from anywhere. <br/>Sicunet Mobile Pro delivers a complete, professional-grade mobile solution for managing your security system with confidence and ease."

        />

      </section>

      {/* ====================== VIDEO TUTORIAL ====================== */}
      {/* <VideoIntroSection
        title="Video Tutorial"
        productName="Sicunet Mobile Pro"
        videos={videoTutorials}
      /> */}

    </div>
  );
};

export default MobileProContent;